import React, { createContext, useContext, useState, useCallback } from "react";

type ActiveModal = "login" | "register" | null;

interface LoginModalContextType {
  activeModal: ActiveModal;
  isLoginModalOpen: boolean;
  isRegisterModalOpen: boolean;
  openLoginModal: () => void;
  openRegisterModal: () => void;
  closeLoginModal: () => void;
  closeRegisterModal: () => void;
  switchToRegister: () => void;
  switchToLogin: () => void;
}

const LoginModalContext = createContext<LoginModalContextType>({
  activeModal: null,
  isLoginModalOpen: false,
  isRegisterModalOpen: false,
  openLoginModal: () => {},
  openRegisterModal: () => {},
  closeLoginModal: () => {},
  closeRegisterModal: () => {},
  switchToRegister: () => {},
  switchToLogin: () => {},
});

export const useLoginModal = () => useContext(LoginModalContext);

export const LoginModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [activeModal, setActiveModal] = useState<ActiveModal>(null);

  const openLoginModal = useCallback(() => setActiveModal("login"), []);
  const openRegisterModal = useCallback(() => setActiveModal("register"), []);
  const closeLoginModal = useCallback(() => setActiveModal(null), []);
  const closeRegisterModal = useCallback(() => setActiveModal(null), []);
  const switchToRegister = useCallback(() => setActiveModal("register"), []);
  const switchToLogin = useCallback(() => setActiveModal("login"), []);

  return (
    <LoginModalContext.Provider
      value={{
        activeModal,
        isLoginModalOpen: activeModal === "login",
        isRegisterModalOpen: activeModal === "register",
        openLoginModal,
        openRegisterModal,
        closeLoginModal,
        closeRegisterModal,
        switchToRegister,
        switchToLogin,
      }}
    >
      {children}
    </LoginModalContext.Provider>
  );
};
